<template>
    <section>
        <header class="m-0 mb-6">
            <h1 class="fs-32 m-0 regular">
                <span v-if="isRenew">{{
                    $l10n.__("Finalisez votre renouvellement d'abonnement")
                }}</span>
                <span v-else>{{ $l10n.__('Finalisez votre abonnement') }}</span>
            </h1>
        </header>
        <article class="mt-6">
            <header>
                <h2 class="m-0">{{ $l10n.__('Informations de contact') }}</h2>
            </header>
            <el-form-item ref="name" prop="name">
                <card background="lightgrey" class="card-contact mt-5 flex-row br fs-3 flex-top">
                    <ul class="my-0 gray-60 semibold">
                        <li class="mb-2">{{ $l10n.__('Prénom et Nom') }}</li>
                        <li class="mb-2">{{ $l10n.__('Email') }}</li>
                        <li>{{ $l10n.__('Téléphone') }}</li>
                    </ul>
                    <ul class="ml-5 my-0">
                        <li class="mb-2">{{ contact.forename }} {{ contact.name }}</li>
                        <li class="mb-2">{{ contact.email }}</li>
                        <li>{{ contact.phone.e164 }}</li>
                    </ul>
                    <a
                        class="flex-item-right link"
                        :disabled="computeLoading"
                        @click="contactDialog = !computeLoading ? true : false"
                        >{{ $l10n.__('Modifier') }}</a
                    >
                </card>
            </el-form-item>
        </article>

        <el-dialog
            :title="$t.__('pages.account.client.PaymentCart.edit_contact_informations')"
            :modelValue="contactDialog"
            width="480"
            class="dialog-cart-contact"
            @close="handleFormClose"
        >
            <cart-contact-form
                v-if="contactDialog"
                :contact="contact"
                @close="contactDialog = false"
            ></cart-contact-form>
        </el-dialog>

        <span class="separator block my-6"></span>
        <article>
            <!-- Billing Settings -->
            <h2 class="mt-0 mb-5">{{ $l10n.__('Informations de facturation') }}</h2>
            <el-form-item :label="$t.__('pages.account.client.PaymentCart.company_name')">
                <el-input :modelValue="corpName" disabled></el-input>
            </el-form-item>
            <address-input v-model="addressSettings">
                <template #manualAddress="{ data, updateCountry }">
                    <el-form-item
                        prop="billingSettings.line1"
                        :label="$t.__('common.labels.street_name')"
                    >
                        <el-input v-model="data.line1" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item
                        :label="
                            $l10n.__('Informations supplémentaires (bâtiment, étage, bureau, ...)')
                        "
                    >
                        <el-input v-model="data.line2" autocomplete="off"></el-input>
                    </el-form-item>
                    <div class="flex-row">
                        <el-form-item
                            class="wp-3"
                            prop="billingSettings.postalCode"
                            :label="$t.__('common.labels.postal_code')"
                        >
                            <el-input v-model="data.postalCode" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item
                            class="wp-7 ml-3"
                            prop="billingSettings.city"
                            :label="$t.__('common.labels.city')"
                        >
                            <el-input v-model="data.city" autocomplete="off"></el-input>
                        </el-form-item>
                    </div>
                    <div class="flex-row">
                        <el-form-item class="wp-5" :label="$t.__('common.labels.state')">
                            <el-input v-model="data.administrative" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item
                            class="wp-5 ml-3"
                            prop="billingSettings.country"
                            :label="$t.__('common.labels.country')"
                        >
                            <country-input
                                :defaultValue="{
                                    code: data.countryCode,
                                    name: data.country,
                                }"
                                @change="updateCountry"
                            >
                            </country-input>
                        </el-form-item>
                    </div>
                </template>
                <template #algoliaWrapper="{ methods, props, data }">
                    <el-form-item
                        prop="billingSettings.line1"
                        :label="$t.__('common.labels.street_name')"
                        :class="{ hide: data.currentValue.manualMode }"
                    >
                        <algolia-input
                            :elementName="props.modelValue._id"
                            placeType="address"
                            @bubble-address="methods.captureAddress"
                        ></algolia-input>
                        <CompassButton
                            :label="props.manuallyLabel"
                            type="tertiary"
                            class="b-0 pl-0 mt-1"
                            @click="methods.switchMode"
                        />
                    </el-form-item>
                </template>
            </address-input>
            <div class="flex-row">
                <el-form-item
                    class="wp-5"
                    prop="billingLocale"
                    :label="$t.__('common.labels.invoicing_language')"
                >
                    <el-select v-model="contact.billingLocale" class="wp-10">
                        <el-option
                            v-for="locale in billingLocales"
                            :key="locale.code"
                            :label="locale.name"
                            :value="locale.code"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item
                    class="wp-5 ml-4"
                    :label="$t.__('common.labels.tax_number')"
                    prop="vatIntra"
                >
                    <el-input v-model="tvaIntra"></el-input>
                </el-form-item>
            </div>
        </article>

        <span class="separator block my-6"></span>
        <article>
            <header class="flex-row ai-center">
                <h2 class="my-0">{{ $l10n.__('Informations de paiement') }}</h2>
                <span v-if="isCardMethod" class="gray-60 fs-2 flex-item-right"
                    ><i class="icon-lock-fillout"></i> {{ $l10n.__('Paiement sécurisé SSL') }}</span
                >
            </header>

            <!-- IF CREDIT CARD METHOD PAYMENT -->
            <cart-stripe-form
                v-if="isCardMethod"
                ref="CartStripeForm"
                :store="store"
            ></cart-stripe-form>

            <!-- IF BANK TRANSFERT -->
            <div v-if="isManualMethod" class="mb-4">
                <p class="mt-2 mb-3 fs-3">{{ $l10n.__('Paiement par virement') }}</p>
                <div class="alert alert-info alert-payment lh-20 br fs-3">
                    {{
                        $l10n.__(
                            'Une fois la validation de votre souscription effectuée, vous receverez un email contenant les informations nécessaires pour procéder au virement.',
                        )
                    }}
                </div>
            </div>
            <!-- External payer checkbox -->
            <el-form-item prop="billingContactPayer">
                <el-checkbox
                    v-model="isBillingContactPayer"
                    label="external"
                    class="cart-thirdpayer--checkbox"
                >
                    {{ $l10n.__('Ce n’est pas vous qui payez ?') }}
                    <p class="fs-2 gray-60 my-0">
                        {{
                            $l10n.__(
                                'Faites payer votre abonnement Sellsy par un membre de votre société (comptable, direction).',
                            )
                        }}
                    </p>
                </el-checkbox>
                <template v-if="isBillingContactPayer">
                    <div class="alert alert-info mt-3 mb-0 alert-payment lh-20">
                        {{
                            $l10n.__(
                                'Dès que vous aurez validé la souscription, vous recevrez un email récapitulatif contenant un lien public pour procéder au paiement. Transmettez le lien de cette page à la personne en charge du paiement pour finaliser votre abonnement ou saisissez son email ci-dessous.',
                            )
                        }}
                    </div>
                    <p class="mt-3 mb-2 fs-3">
                        {{
                            $l10n.__(
                                'Envoyez le lien de la page de paiement par email à la personne en charge du paiement',
                            )
                        }}
                    </p>
                    <el-form-item
                        :label="
                            $t.__('pages.account.client.PaymentCart.recipient_email_for_payment')
                        "
                        prop="billingContactPayerEmail"
                    >
                        <el-input
                            v-model="billingContactPayerEmail"
                            type="email"
                            autocomplete="off"
                        ></el-input>
                    </el-form-item>
                </template>
            </el-form-item>
        </article>
    </section>
</template>

<script>
import Address from 'vcomponents/inputs/custom/Address.vue';
import CountryInput from 'vcomponents/inputs/CountryInput.vue';
import AlgoliaInput from 'vcomponents/inputs/AlgoliaInput.vue';
import { createNamespacedHelpers } from 'vuex';
import Card from 'vcomponents/Card.vue';
import CartContactForm from 'vcomponents/pages/account/client/CartContactForm.vue';
import CartStripeForm from 'vcomponents/pages/account/CartStripeForm.vue';

const corp = createNamespacedHelpers('corp');

export default {
    props: {
        store: {
            type: String,
            required: false,
            default: 'client',
        },
    },
    data() {
        return {
            contactDialog: false,
        };
    },
    computed: {
        ...corp.mapGetters(['corpName']),
        contact() {
            return this.$store.getters[`${this.store}Cart/contact`];
        },
        billingSettings() {
            return this.$store.getters[`${this.store}Cart/billingSettings`];
        },
        isBillingContactPayer: {
            get() {
                return this.$store.getters[`${this.store}Cart/isBillingContactPayer`];
            },

            /**
             * If the value is true, then set the payment as external payer (else stripe_card)
             * and clear all values of credit card for the form && stripe.
             *
             * value (boolean)
             */
            set(value) {
                this.$store.commit(`${this.store}Cart/setBillingContactPayer`, value);
                if (this.isCardMethod) {
                    this.$refs.CartStripeForm.resetCardInputs(value);
                }
            },
        },
        billingContactPayerEmail: {
            get() {
                return this.$store.getters[`${this.store}Cart/billingContactPayerEmail`];
            },
            set(value) {
                this.$store.commit(`${this.store}Cart/setBillingContactPayerEmail`, value);
            },
        },
        computeLoading() {
            return this.$store.getters[`${this.store}Cart/computeLoading`];
        },
        billingLocales() {
            return this.$store.getters[`${this.store}Cart/billingLocales`];
        },
        vatIntra() {
            return this.$store.getters[`${this.store}Cart/vatIntra`];
        },
        paymentMethod() {
            return this.$store.getters[`${this.store}Cart/paymentMethod`];
        },
        isManualMethod() {
            return this.$store.getters[`${this.store}Cart/isManualMethod`];
        },
        isCardMethod() {
            return this.$store.getters[`${this.store}Cart/isCardMethod`];
        },
        addressSettings: {
            get() {
                return this.billingSettings;
            },
            set(value) {
                this.$store.commit(`${this.store}Cart/setBillingSettings`, value);
                this.$store.dispatch(`${this.store}Cart/computeCart`);
            },
        },
        tvaIntra: {
            get() {
                return this.vatIntra;
            },
            set(value) {
                this.$store.commit(`${this.store}Cart/setVatIntra`, value);
                this.$store.dispatch(`${this.store}Cart/computeCart`);
            },
        },
        isRenew() {
            return this.$store.getters[`${this.store}Cart/isRenew`];
        },
        isUpsell() {
            return this.$store.getters[`${this.store}Cart/isUpsell`];
        },
    },
    methods: {
        handleFormClose() {
            this.contactDialog = false;
            this.$refs['name'].validate();
        },
    },
    components: {
        Card,
        CartContactForm,
        'address-input': Address,
        CountryInput,
        AlgoliaInput,
        CartStripeForm,
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;
.el-form-item.is-error {
    .card-contact {
        border-color: $red !important;
    }
}

.alert.alert-payment {
    padding: 6px 16px;
}

.cart-thirdpayer--checkbox {
    .el-checkbox__input {
        margin-top: 3px;
        padding-top: 0;
    }
    .el-checkbox__label {
        line-height: 20px;
        padding-left: 8px;
        p {
            line-height: 16px;
            white-space: normal;
        }
    }
}

.dialog-cart-contact {
    .el-dialog__close.el-icon-close {
        color: $gray-100;
    }
}
</style>
